import { theme } from 'antd';
import { DeletedFilled, EditIcon } from 'assets/images/svg';
import { useManagePermittedRoles } from 'library/hooks';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectSiteByOrgAndSiteID } from 'reduxStore/sites/selectors';
import { DeleteSiteModal, UpdateSiteModal } from 'zComponents/molecules';
import { Button, Flex, Tooltip, Typography } from 'zui/Antd';

const { Title, Text } = Typography;

const ViewSiteHeader = ({ siteID }) => {
	// Hooks
	const {
		token: { fontSizeSM }
	} = theme.useToken();

	// Redux state
	const site = useSelector((state) => selectSiteByOrgAndSiteID(state, siteID));

	// Local state
	const [openUpdateModal, setOpenUpdateModal] = useState(false);
	const [openDeleteModal, setOpenDeleteModal] = useState(false);

	// Determine if is permitted to edit site
	const isPermittedUpdateSite = useManagePermittedRoles('updateSite', {
		101: [site?.orgID],
		103: [site?.siteID]
	});

	// Determine if is permitted to delete site
	const isPermittedDeleteSite = useManagePermittedRoles('deleteSite', {
		101: [site?.orgID],
		103: [site?.siteID]
	});

	const permissionDeniedMessage = "You don't have permission to perform this action.";

	//Handle stop propagation for buttons
	const handleStopPropagation = (e) => {
		e.stopPropagation();
	};

	return (
		<>
			<Flex justify='space-between' align='center'>
				<Flex vertical>
					<Title level={5} style={{ margin: 0 }}>
						{site?.name || 'Unknown Site'}
					</Title>
					<Text style={{ fontSize: fontSizeSM }}>{site?.fullAddress || 'No address provided'}</Text>
				</Flex>
				<Flex gap={8} onClick={handleStopPropagation}>
					<UpdateSiteModal siteID={site.siteID} setOpen={setOpenUpdateModal} open={openUpdateModal}>
						<Tooltip title={!isPermittedUpdateSite ? permissionDeniedMessage : 'Edit Site'}>
							<Button
								type='text'
								size='small'
								icon={<EditIcon color='currentColor' />}
								disabled={!isPermittedUpdateSite}
								onClick={(e) => setOpenUpdateModal(true)}
							/>
						</Tooltip>
					</UpdateSiteModal>
					<DeleteSiteModal siteID={site.siteID} setOpen={setOpenDeleteModal} open={openDeleteModal}>
						<Tooltip title={!isPermittedDeleteSite ? permissionDeniedMessage : 'Delete Site'}>
							<Button
								type='text'
								size='small'
								icon={<DeletedFilled width={16} height={16} color='currentColor' />}
								disabled={!isPermittedDeleteSite}
								onClick={(e) => setOpenDeleteModal(true)}
							/>
						</Tooltip>
					</DeleteSiteModal>
				</Flex>
			</Flex>
		</>
	);
};

export default ViewSiteHeader;
